import { all } from 'redux-saga/effects'

import { entriesSaga } from './entries/sagas'

export function* faqSaga() {
  yield all([entriesSaga()])
}
